import _indexOf from './_indexOf.js';

export default function _includes(a, list) {
  return _indexOf(list, a, 0) >= 0;
}


// WEBPACK FOOTER //
// /app/apps/ms/node_modules/ramda/es/internal/_includes.js